export default {
  foldersList: [],
  one_folder: {},
  main_window: {
    parent: null,
    children: [],
  },
}
